<div class="loader-overlay" [class.visible]="isLoading()">
  <div class="spinner-container">
    <div class="spinner"></div>
  </div>
</div>
